const initialState = {
    batteryAPIURL: ''
  };
  
  const baseUrlbatteryReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_BASE_URL_BATTERY':
            return { ...state, batteryAPIURL: action.payload };
        default:
            return state;
    }
  };
  
  export default baseUrlbatteryReducer;
  